import React from 'react';


/**
 * A React Hook that sets a value which is incremented with every setter call.
 * @param startValue - the counter's initial value. Defaults to `0`.
 * @param setterFn - defines the behavior of the setter function. Defaults to incrementing the current value by
 * `1`.
 * @returns Array where first item is the initial value, the second item is a function that increments the count when
 *          called, and the third item is a function that resets the count to its initial value
 */
export const useCounter = (
  startValue: number | (() => number) = 0,
  setterFn: (value: number) => number = value => value + 1,
): [number, () => void, () => void] => {
  const [value, setValue] = React.useState(startValue);

  return [value, () => setValue(setterFn(value)), () => setValue(startValue)];
};
